import React from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { get } from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './EditEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    campusName: Yup.string()
        .max(45)
        .required()
});

const EditCampusModal = ({
    close,
    clearErrors,
    open,
    title,
    isLoading,
    errors,
    toggleLoading,
    ...props
}) => {
    const formik = useFormik({
        initialValues: {
            campusName: get(props, 'selectedNode.name', '')
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                companyInfo,
                selectedClient,
                selectedNode,
                updateCampus
            } = props;

            const body = {
                name: values.campusName
            };

            let isUpdated;

            clearErrors();
            setSubmitting(true);
            try {
                if (!isLoading) {
                    toggleLoading(true);
                    isUpdated = await updateCampus(selectedNode.id, selectedClient.id, companyInfo, body);
                }

                if (isUpdated) {
                    handleClose();
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();

        close();
    };

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onRendered={formik.handleReset}
            onConfirm={formik.handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
            confirmText="Update"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/campusTreeIcon.svg" alt="new entity icon" />
                        <span>Edit Campus</span>
                    </div>
                    <p>
                        Enter a Campus name.
                    </p>
                    <div className={classes.labelContent} />
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="campusName"
                                name="campusName"
                                type="text"
                                value={formik.values.campusName}
                                label="Campus Name"
                                onChange={formik.handleChange}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                error={Boolean(formik.errors.campusName)}
                                helperText={formik.errors.campusName}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

EditCampusModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo:    state.companyInfo,
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedClient: state.client.selectedClient,
        selectedNode:   state.architect.selectedNode
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCampusModal);
